<template>
  <div class="right">
    <User></User>
    <router-view></router-view>
  </div>
</template>
  
  <script>
import User from './User.vue'

export default {
  components: { User },

}
  </script>
  <style scoped>
.right {
  min-width: 1100px;
  height: 100%;
  background: #fff;
  display: grid;
  grid-template-rows: 81px auto;
}
</style>
  